/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminCompleteMatchBody
 */
export interface AdminCompleteMatchBody {
    /**
     * 
     * @type {number}
     * @memberof AdminCompleteMatchBody
     */
    homeScore: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCompleteMatchBody
     */
    awayScore: number;
}

/**
 * Check if a given object implements the AdminCompleteMatchBody interface.
 */
export function instanceOfAdminCompleteMatchBody(value: object): value is AdminCompleteMatchBody {
    if (!('homeScore' in value) || value['homeScore'] === undefined) return false;
    if (!('awayScore' in value) || value['awayScore'] === undefined) return false;
    return true;
}

export function AdminCompleteMatchBodyFromJSON(json: any): AdminCompleteMatchBody {
    return AdminCompleteMatchBodyFromJSONTyped(json, false);
}

export function AdminCompleteMatchBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCompleteMatchBody {
    if (json == null) {
        return json;
    }
    return {
        
        'homeScore': json['homeScore'],
        'awayScore': json['awayScore'],
    };
}

export function AdminCompleteMatchBodyToJSON(json: any): AdminCompleteMatchBody {
    return AdminCompleteMatchBodyToJSONTyped(json, false);
}

export function AdminCompleteMatchBodyToJSONTyped(value?: AdminCompleteMatchBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'homeScore': value['homeScore'],
        'awayScore': value['awayScore'],
    };
}

